<script lang="ts">
  import AUButtonIcon from "component_library/components/svelte/ui/AUButtonIcon.svelte"
  import Send from "@autouncle/icons/dist/assets/send.svg?raw"
  import type { LicensePlateCountry } from "website_script/types/settings"
  import DKPlate from "component_library/shared/assets/numberPlateDk.svg?raw"
  import SEPlate from "component_library/shared/assets/numberPlateSe.svg?raw"
  import GBPlate from "component_library/shared/assets/numberPlateGb.svg?raw"
  import NLPlate from "component_library/shared/assets/numberPlateNl.svg?raw"
  import IPlate from "component_library/shared/assets/numberPlateIt.svg?raw"
  import ESPlate from "component_library/shared/assets/numberPlateEs.svg?raw"
  import Svg from "website_script/components/Svg.svelte"
  import { getContext } from "svelte"
  import type { Texts } from "website_script/types/texts"

  const { tradeInPromptCtaTitle, lpnInputPLaceholder } =
    getContext<Texts>("texts")

  export let onSubmit: (licensePlateNumber: string) => void
  let licensePlateNumber: string = ""
  export let licensePlateCountry: LicensePlateCountry

  const countryPlate = (country: LicensePlateCountry) => {
    switch (country) {
      case "DK":
        return DKPlate
      case "SE":
        return SEPlate
      case "GB":
        return GBPlate
      case "NL":
        return NLPlate
      case "I":
        return IPlate
      case "E":
        return ESPlate
      default:
        return ""
    }
  }

  const handleSubmit = () => {
    onSubmit(licensePlateNumber.trim())
    licensePlateNumber = ""
  }
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<div class="wrapper" on:click|stopPropagation on:keydown={() => null}>
  <form
    class="lpn-form"
    on:submit|preventDefault={handleSubmit}
    data-country={licensePlateCountry}
  >
    <Svg
      alt={licensePlateCountry}
      height="40"
      aria-hidden="true"
      strokeWidth="0px"
      data={countryPlate(licensePlateCountry)}
    />

    <div class="shadow" />
    <label for="lpn-input" class="au-sr-only">{lpnInputPLaceholder}</label>
    <div class="control">
      <input
        type="text"
        placeholder={lpnInputPLaceholder}
        bind:value={licensePlateNumber}
        id="lpn-input"
      />
      <AUButtonIcon
        size="sm"
        color="primary"
        sroText={tradeInPromptCtaTitle}
        icon={Send}
        onClick={handleSubmit}
        data-testid="submit"
      />
    </div>
  </form>
</div>

<style>
  .wrapper {
    display: contents;
  }

  .lpn-form {
    max-width: 220px;
    margin: 0 auto;
    display: flex;
    border: 2px solid var(--au-text-color-default);
    border-radius: var(--au-border-radius-sharp);
  }
  .lpn-form:focus-within {
    outline: 2px solid #005fcc;
  }

  .lpn-form[data-country="DK"] {
    border-color: #ef5350;
  }

  .lpn-form > :global(svg) {
    border-top-left-radius: calc(var(--au-border-radius-sharp) / 2);
    border-bottom-left-radius: calc(var(--au-border-radius-sharp) / 2);
    flex-shrink: 0;
  }

  .lpn-form :global(.au-button-icon) {
    --au-button-border-radius: var(--au-border-radius-sharp);
  }

  .shadow {
    background-color: #e6e6e6;
    width: 6px;
    height: var(--au-tappable-size);
    flex-shrink: 0;
  }

  .control {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0 var(--au-spacing-xs);
    gap: var(--au-spacing-xs);
  }

  .control > input {
    margin: 0;
    outline: none;
    border: none;
    width: 100%;
    padding: 0;

    font-size: var(--au-text-heading-1-font-size);
    font-weight: var(--au-text-weight-bold);
    color: var(--au-text-color-default);
    text-transform: uppercase;
    text-align: center;
  }

  .control > input ::-webkit-input-placeholder,
  .control > input ::-moz-placeholder,
  .control > input ::-ms-input-placeholder,
  .control > input ::placeholder {
    color: var(--au-text-color-body);
  }

  .control > input ::-moz-placeholder {
    opacity: 1;
  }
</style>
